const parents = {
  tabs: {
    history: 'Histórico',
    information: 'Informação',
  },

  headerButtons: {
    create: {
      createBtn: 'Criar',
    },
  },

  modal: {
    header: 'Alterar Status',
    body: 'Você tem certeza de que deseja alterar o status dos pais para ',
  },

  deleteModal: {
    header: 'Excluir os Pais',
    body: 'Você está prestes a excluir {{num}} pais.',
  },

  edit: {
    tabs: {
      information: 'Informações Gerais',
      linkStudent: 'Conectar Aluno',
      history: 'Histórico',
    }
  },

  table: {
    statuses: {
      active: 'Ativo',
      inactive: 'Inativa',
    },

    actions: {
      delete: 'Remover',
    },

    header: {
      createBtn: 'Criar',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      status: 'Status',
      address: 'Endereço',
      createdBy: 'Criado por',
      createdAt: 'Criado em',
    },
  },
  form: {
    header: {
      create: {
        title: 'Criar',
      },

      update: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    actions: {
      header: 'Ações',
      buttons: {
        resetPassword: 'Redefinir Senha',
      },
    },

    create: {
      toasts: {
        success: 'Principal criado com sucesso',
        error: 'Ocorreu um erro ao criar o principal',
      },
    },
    update: {
      activeStatus: {
        statusActive: 'Ativo',
        statusDeactivate: 'Inativa',
      },

      suspend: {
        actionActivate: 'Reativar',
        actionDeactivate: 'Suspender',
        suspendModal: {
          popupTitleDeactivation: 'Suspender passageiro',
          popupTitleActive: 'Motivo de Suspensão',
          popupTitleUnsuspend: 'Motivo de Anular a Suspensão',
          popupSubTitleDeactivation: 'Selecione o motivo da suspensão',
          popupActionActive: 'Reativar Passageiro',
          popupActionDeactivate: 'Suspender passageiro',
        },
      },
      toasts: {
        success: 'Principal atualizado com sucesso',
        error: 'Ocorreu um erro ao atualizar a principal',
        fetchError: 'Ocorreu um erro, por favor, tente novamente.',
      },
    },
    sections: {
      groups: {
        header: 'Local & Perfil',
        fields: {
          profile: {
            label: 'Perfil',
          },
        },
      },
      personalDetails: {
        header: 'Detalhes pessoais',
        fields: {
          firstName: {
            label: 'Nome',
          },
          lastName: {
            label: 'Sobrenome',
          },
          email: {
            label: 'E-mail',
          },
          phone: {
            label: 'Telefone',
          },
          additionalPhone: {
            label: 'Telefone adicional',
          },
          address: {
            label: 'Endereço',
          },
        },
      },
      linkStudent: {
        header: 'Alunos',
        add: 'Adicionar',
        entity: 'Alunos',
      },
    },
  },

  studentsTable: {
    headers: {
      name: 'Nome',
      address: 'Endereço',
      phone: 'Telefone',
      email: 'E-mail',
    },
  },
};

export default parents;
